import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ConfirmationDialogComponent} from './confirmation-dialog.component';
import {TranslateModule} from "@ngx-translate/core";
import {ValgInputModule} from '../input/input.module';


@NgModule({
  declarations: [
    ConfirmationDialogComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    ValgInputModule,
  ]
})
export class ConfirmationDialogModule {
}
